import styled from "@emotion/native";

import Text from "../../components/Text";
import { ViewStyle } from "react-native";

import { AppTheme } from "../../utils/theme";

export const Container = styled.View({
	paddingHorizontal: 13,
	justifyContent: "center",
});

export const Hero = styled.View(
	{
		alignSelf: "center",
		paddingHorizontal: 15,
		paddingVertical: 16,
		flexDirection: "row",
	},
	({ hasDetails, theme }: any) => {
		let {
			color: { backgroundAccent2 },
		} = theme as AppTheme;
		let style: ViewStyle = {
			backgroundColor: backgroundAccent2,
		};

		if (hasDetails) {
			style = {
				...style,
				paddingBottom: 48,
			};
		}

		return style;
	}
);

export const HeroCta = styled.TouchableOpacity(
	{
		width: "80%",
		alignItems: "center",
		alignSelf: "center",
		marginTop: -28,
		paddingVertical: 5,
		paddingHorizontal: 10,
		borderRadius: 12,
	},
	({ theme }: any) => {
		return {
			backgroundColor: theme.color.enabled,
		};
	}
);

export const PercentageIndicator = styled.View({
	borderColor: "white",
	borderWidth: 7,
	borderRadius: 50,
	height: 100,
	width: 100,
	justifyContent: "center",
	alignItems: "center",
});
export const CtaTitle = styled(Text)({
	width: "60%",
	paddingTop: 6,
	marginLeft: 20,
	fontSize: 18,
});

/**
 * What's all this then?
 *
 * LineHeight values are assumed to be pixels and not unitless vaules
 *
 * There is a small incompatibility with
 * react-native-builder-bob and @emotion/native
 *
 * Once compiled the stylesheets are converted using
 * css-to-react-native under the hood.
 *
 * When bundled by react-native-builder-bob the lineHeight
 * value is not explicitly converted (because a unitless line-height is allowed)
 *
 * This triggers warning in the child application using this as a dependency
 *
 * Warnings are bad m'kay?
 */
export const CtaDetails = styled(Text)`
	text-align: center;
	font-size: 16px;
	font-weight: 500;
	line-height: 22px;
`;
